<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Integrações Trinka para sua Empresa</h1>
                        <p style="margin: 0 0 10px 0;">Integre facilmente Trinka em seus fluxos de trabalho corporativos e dê à sua equipe acesso a todos
                            os recursos poderosos de Trinka.</p>
                        <!-- <button routerLink="/contactus">Get Started</button> -->
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Contate-nos</button>
                        <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get Started</a> -->
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/enterprise_banner_img.png" alt="enterprise banner">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>Aprovado por Líderes Globais</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="universities">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/UNSW.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="universities">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="universities">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="other_comparision">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>Soluções Adequadas à Indústria para Redação Aprimorada</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka ajuda as suas equipes a criarem documentos profissionais de forma eficiente, garantindo qualidade
                            e consistência.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>Ciências Biológicas, Medicina & Farmacêutica</h3>
                        </div>
                        <p>O poderoso verificador Trinka AI entende as complexidades técnicas e a precisão exigidas na redação
                            médica e científica. As sugestões de Trinka são contextuais e específicas para cada assunto.
                        </p>
                        <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">Leia Mais
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>Serviços de Linguagem, Publicação & Midia</h3>
                        </div>
                        <p>Permite que suas equipes escrevam de forma consistente, publiquem com mais rapidez e permite que
                            aumentem a experiência do cliente. Reduz o tempo e os custos de redação sem comprometer a qualidade.</p>
                        <a [routerLink]="['/enterprise/language-services-publishing-and-media']">Leia Mais
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>Instituições Acadêmicas</h3>
                        </div>
                        <p>Trinka aprimora sua redação para cumprir as convenções de redação acadêmica e as melhores práticas
                            para torná-la pronta para publicação.</p>
                        <a [routerLink]="['/enterprise/academic-institutions']">Leia Mais
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>K-12 e E-Learning</h3>
                        </div>
                        <p>Trinka AI avançada não só ajuda os alunos a melhorarem sua escrita, mas também a aprenderem as melhores
                            práticas de redação acadêmica enquanto escrevem.</p>
                        <a [routerLink]="['/enterprise/k12-and-elearning']">Leia Mais
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>Plataformas de Tecnologia</h3>
                        </div>
                        <p>Trinka permite que você adicione suporte de redação em tempo real ao seu aplicativo com facilidade.
                            Construa soluções exclusivas, oferecendo as sugestões de redação de Trinka.</p>
                        <a [routerLink]="['/enterprise/technology-platforms']">Leia Mais
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>3 Maneiras de Integrar Trinka</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Potencializa todas as suas equipes para escrever melhor. Os usuários corporativos obtêm acesso ilimitado
                            e benefícios atraentes. Escolha a opção de integração mais adequada para sua necessidade.</p>
                    </div>
                </div>
            </div>
            <div class="row divider_line_section">
                <div class="col-lg-5">
                    <div class="integreate_img_section GetTrinkaJs_img">
                        <img class="getTrinkajs_gif_img" src="../../../assets/images/GetTrinkaJs.gif" alt="get trinka js">
                        <img class="getTrinkaJs_backgrond" src="../../../assets/images/API_backgrond_layer.png" alt="API">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>01</span> Get Trinka
                            <b style="padding: 0px 12px 4px 12px;">JS</b>
                        </h3>
                        <p>Ative a Trinka para todos os membros da sua equipe simplesmente inserindo um pequeno trecho de código
                            JavaScript (JS) no seu navegador ou em qualquer aplicativo. Evite a necessidade de integrações
                            complicadas e obtenha o poder da Trinka com este recurso fácil de usar.</p>
                        <ul>
                            <li>
                                <h4>Integração simples</h4>
                                <p>Basta inserir um pequeno trecho de JavaScript em seu aplicativo e permitir que seus usuários
                                    comecem a escrever melhor com a Trinka.</p>
                            </li>
                            <li>
                                <h4>Seguro e seguro</h4>
                                <p>Todos os seus dados estão em um ambiente altamente criptografado. O TrinkaJs funciona em
                                    tempo real e não salva nada em nossos servidores.</p>
                            </li>
                            <li>
                                <h4>Flexibilidade incomparável</h4>
                                <p>O snippet JS simples de usar é fácil de integrar e resiliente também. Ele é facilmente dimensionado
                                    com sua equipe e negócios em crescimento.</p>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>

            <div class="row divider_line_section columu_reverse">
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>02</span> Obter Trinka
                            <b>API</b>
                        </h3>
                        <p>Precisa da Trinka dentro do seu produto? A poderosa API da Trinka permite que você integre facilmente
                            em qualquer aplicativo. A API simples de usar oferece alta confiabilidade e escalabilidade.</p>
                        <ul>
                            <li>
                                <h4>API robusta</h4>
                                <p>A Trinka API oferece alta disponibilidade de serviço para que você obtenha a ajuda que você
                                    precisa quando quiser.</p>
                            </li>
                            <li>
                                <h4>Personalizações de API</h4>
                                <p>Tem necessidades exclusivas para sua aplicação? Apenas pergunte. A Trinka API é altamente
                                    personalizável.
                                </p>
                            </li>
                            <li>
                                <h4>Flexibilidade incomparável</h4>
                                <p>A poderosa API também é fácil de usar e resiliente. A Trinka combina com sua escala de produtos
                                    para escalar.</p>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_API">
                        <img class="API_bg_layer" src="../../../assets/images/API_backgrond_layer.png" alt="api">
                        <img class="TrinkaAPI_img" src="../../../assets/images/TrinkaAPI_img.png" alt="trinka api">
                        <div class="API_text_section" data-aos="zoom-in">
                            <span></span>
                            <div class="API_text_overlay"></div>
                            <img src="../../../assets/images/API_text.png" alt="api">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_on_premise">
                        <img src="../../../assets/images/GetTrinkaOn_Premise.png" alt="on premise">
                        <span class="TrinkaPurpleColor"></span>
                        <span class="TrinkaredColor"></span>
                        <span class="TrinkaYellowColor"></span>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>03</span> Tenha a Trinka
                            <b class="mobile_view">no seu site</b>
                        </h3>
                        <p>Trabalhando com dados altamente confidenciais? Então a Trinka On-Premise é a melhor solução para
                            você! Faça com que a Trinka trabalhe para você em sua infraestrutura corporativa.</p>
                        <ul>
                            <li>
                                <h4>Suporte Dedicado</h4>
                                <p>Com a Trinka On-Premise, você obtém pessoal de serviço dedicado trabalhando especificamente
                                    com sua equipe de TI para integração sem problemas.</p>
                            </li>
                            <li>
                                <h4>Seguro e seguro</h4>
                                <p>Com a Trinka IA trabalhando em sua infraestrutura empresarial, seus dados estão completamente
                                    seguros e projetigos.</p>
                            </li>
                            <li>
                                <h4>Flexibilidade incomparável</h4>
                                <p>Com fácil integração e serviço de suporte dedicado, a Trinka se expande facilmente com a
                                    crescente equipe e negócios da sua organização.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="enterprise_contactUs">
        <p>Receba um orçamento personalizado</p>
        <button data-toggle="modal" data-target="#EnterPriseContactPopup"
            class="plansButtons" type="submit">Solicitar uma Demonstração</button>
    </div>
</div>


<app-enterprise-modal></app-enterprise-modal>